export const viewModes = {
    VIEW: "view",
    EDIT: "edit",
    ADD: 'add',
}